<template>
  <BaseTemplate app-name="" page-title="">
    <template #content>
      <div class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 p-4 transition-all duration-300">
        <div class="w-full bg-white/80 dark:bg-black/10 backdrop-blur-md dark:backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-lg p-4 mb-6 shadow-lg shadow-black/20">
          <div class="flex flex-wrap items-end gap-3">
            <div v-if="filtroCodigo" class="flex items-end">
              <button
                @click="voltarLista"
                class="px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg transition-all duration-200 font-medium flex items-center gap-2"
              >
                <ArrowLeft class="h-4 w-4" />
                <span>Voltar</span>
              </button>
            </div>
            <div class="min-w-[240px]">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Unidade</label>
              <select
                v-model="filtroUnidade"
                class="w-full px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all"
              >
                <option value="" class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">Todas as unidades</option>
                <option
                  v-for="unit in unidades"
                  :key="unit.id"
                  :value="String(unit.id)"
                  class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                >
                  {{ unit.nome || `Unidade ${unit.id}` }}
                </option>
              </select>
            </div>

            <div class="min-w-[260px] flex-1">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Código</label>
              <select
                v-model="filtroCodigo"
                class="w-full px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all"
              >
                <option value="" class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">Selecione um código</option>
                <option
                  v-for="cod in codigosDisponiveis"
                  :key="cod"
                  :value="cod"
                  class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                >
                  {{ cod }}
                </option>
              </select>
            </div>

            <div class="min-w-[190px]">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Agente (valor)</label>
              <select
                v-model="filtroAgente"
                :disabled="!filtroCodigo || isLoadingAgentesOpcoes"
                class="w-full px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all disabled:opacity-70 disabled:cursor-not-allowed"
              >
                <option value="" class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">Todos os agentes</option>
                <option
                  v-for="ag in agentesOpcoes"
                  :key="ag"
                  :value="ag"
                  class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                >
                  {{ ag }}
                </option>
              </select>
            </div>

            <div class="min-w-[160px]">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Data início</label>
              <input
                v-model="dataInicio"
                type="date"
                :min="minDiaDisponivel"
                :max="maxDiaDisponivel"
                class="w-full px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all"
              />
            </div>

            <div class="min-w-[160px]">
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Data fim</label>
              <input
                v-model="dataFim"
                type="date"
                :min="minDiaDisponivel"
                :max="maxDiaDisponivel"
                class="w-full px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all"
              />
            </div>

            <div class="flex items-center gap-2">
              <button
                @click="filtrarHoje"
                class="px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg transition-all duration-200 font-medium"
              >
                Hoje
              </button>
              <button
                @click="limparFiltros"
                class="px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg transition-all duration-200 font-medium flex items-center gap-2"
              >
                <Brush class="h-4 w-4" />
                <span>Limpar</span>
              </button>
              <button
                @click="atualizarTudo"
                :disabled="isLoading"
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium disabled:opacity-70 disabled:cursor-not-allowed shadow-md hover:shadow-lg flex items-center gap-2"
              >
                <RefreshCw v-if="isLoading" class="h-5 w-5 animate-spin" />
                <RefreshCw v-else class="h-5 w-5" />
                <span>{{ isLoading ? 'Carregando...' : 'Atualizar' }}</span>
              </button>
            </div>
          </div>

          <div class="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600 dark:text-gray-400">
            <div>
              <span class="font-semibold">Fonte dos Dados:</span> Prontuário Eletrônico da Medilab Sistemas
              <span v-if="lastFetchTime" class="ml-3">Última atualização: {{ lastFetchTime }}</span>
            </div>
            <div v-if="filtroCodigo && maxDiaDisponivel" class="text-gray-700 dark:text-gray-200">
              Intervalo disponível: {{ formatarDia(minDiaDisponivel) }} → {{ formatarDia(maxDiaDisponivel) }}
            </div>
          </div>
        </div>

        <div v-if="error" class="mb-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-200 rounded-lg p-4">
          {{ error }}
        </div>

        <div v-if="!isLoading && !filtroCodigo" class="space-y-4">
          <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-6">
            <div class="flex flex-wrap items-center justify-between gap-2">
              <div>
                <div class="text-sm font-semibold text-gray-900 dark:text-white">SQLs Diversos</div>
                <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                  {{ codigosCards.length }} código(s) disponível(is)
                  <span v-if="ultimaBatidaGeral" class="ml-2">Última batida: {{ formatarDataHora(ultimaBatidaGeral) }}</span>
                </div>
              </div>
              <div class="text-xs text-gray-600 dark:text-gray-300">
                Clique em um card para abrir
              </div>
            </div>
          </div>

          <div v-if="codigosCards.length === 0" class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-8 text-center text-gray-600 dark:text-gray-300">
            Nenhum código disponível para os filtros atuais.
          </div>

          <div v-else class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
            <button
              v-for="c in codigosCards"
              :key="c.codigo"
              @click="selecionarCodigo(c.codigo)"
              class="text-left bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5 hover:shadow-2xl hover:-translate-y-[1px] transition-all"
            >
              <div class="flex items-start justify-between gap-3">
                <div>
                  <div class="text-base font-semibold text-gray-900 dark:text-white">
                    {{ c.codigo }}
                  </div>
                  <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                    {{ c.total_unidades }} unidade(s)
                  </div>
                </div>
                <div class="px-2 py-1 rounded bg-slate-100 dark:bg-gray-700 text-xs text-gray-800 dark:text-gray-100">
                  Abrir
                </div>
              </div>

              <div class="mt-3 text-xs text-gray-600 dark:text-gray-300">
                Última batida: {{ c.ultima_batida ? formatarDataHora(c.ultima_batida) : '-' }}
              </div>
              <div v-if="c.unidades_preview.length" class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                {{ c.unidades_preview.join(' • ') }}
                <span v-if="c.unidades_mais > 0"> +{{ c.unidades_mais }}</span>
              </div>
            </button>
          </div>
        </div>

        <div v-else-if="!isLoading && filtroCodigo && linhasNormalizadas.length === 0 && !error" class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-8 text-center text-gray-600 dark:text-gray-300">
          Nenhum dado encontrado para os filtros atuais.
        </div>

        <div v-else class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Quantidade total</div>
              <div class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ totalQuantidade }}</div>
              <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                {{ formatarDia(dataInicioEfetiva) }} → {{ formatarDia(dataFimEfetiva) }}
              </div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Agentes</div>
              <div class="mt-2 text-3xl font-semibold text-gray-900 dark:text-white">{{ totalAgentes }}</div>
              <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                {{ filtroAgenteValido ? `Filtro: ${filtroAgente}` : 'Sem filtro de agente' }}
              </div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Última batida</div>
              <div class="mt-2 text-lg font-semibold text-gray-900 dark:text-white">
                {{ ultimaBatida ? formatarDataHora(ultimaBatida) : '-' }}
              </div>
              <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                {{ unidadeSelecionadaNome || 'Todas as unidades' }}
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="flex items-center justify-between gap-2 mb-4">
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Quantidade total por dia</div>
              </div>
              <div class="h-[360px]">
                <Line :data="chartTotalPorDiaData" :options="chartTotalPorDiaOptions" />
              </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="flex items-center justify-between gap-2 mb-4">
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Total acumulado</div>
              </div>
              <div class="h-[360px]">
                <Line :data="chartAcumuladoData" :options="chartAcumuladoOptions" />
              </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
              <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Top agentes</div>
                <div class="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-300">
                  <span>Top</span>
                  <input v-model.number="topN" type="number" min="3" max="50" class="w-20 px-2 py-1 rounded border border-gray-300 dark:border-white/10 bg-white/60 dark:bg-white/5 text-gray-900 dark:text-white" />
                </div>
              </div>
              <div class="h-[360px]">
                <Bar :data="chartTopAgentesData" :options="chartTopAgentesOptions" />
              </div>
            </div>
          </div>

          <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
            <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
              <div class="text-sm font-semibold text-gray-900 dark:text-white">Top agentes por dia</div>
              <div class="flex flex-wrap items-center gap-3 text-xs text-gray-600 dark:text-gray-300">
                <label class="flex items-center gap-2 select-none">
                  <input v-model="incluirSomenteAgenteFiltradoNoGrafico" type="checkbox" class="h-4 w-4" />
                  Usar apenas agente filtrado
                </label>
                <label class="flex items-center gap-2 select-none">
                  <input v-model="mostrarMediaMovel" type="checkbox" class="h-4 w-4" />
                  Média móvel 7d (Total)
                </label>
              </div>
            </div>
            <div class="h-[420px]">
              <Line :data="chartAgentesPorDiaData" :options="chartAgentesPorDiaOptions" />
            </div>
          </div>

          <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-5">
            <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
              <div>
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Média por agente</div>
                <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                  Base: {{ mediaBaseDias }} dia(s), {{ mediaBaseSemanas }} semana(s), {{ mediaBaseMeses }} mês(es)
                </div>
              </div>
              <div class="flex flex-wrap items-center gap-2">
                <select
                  v-model="mediaChartType"
                  class="px-2 py-1 rounded border border-gray-300 dark:border-white/10 bg-white/60 dark:bg-white/5 text-gray-900 dark:text-white text-xs"
                >
                  <option value="bar">Barras</option>
                  <option value="line">Linhas</option>
                  <option value="radar">Radar</option>
                  <option value="doughnut">Rosca</option>
                </select>

                <select
                  v-if="mediaChartType === 'doughnut'"
                  v-model="mediaDoughnutMetric"
                  class="px-2 py-1 rounded border border-gray-300 dark:border-white/10 bg-white/60 dark:bg-white/5 text-gray-900 dark:text-white text-xs"
                >
                  <option value="daily">Média diária</option>
                  <option value="weekly">Média semanal</option>
                  <option value="monthly">Média mensal</option>
                </select>

                <button
                  @click="limparSelecaoMediaAgentes"
                  class="px-3 py-1 rounded bg-slate-100 dark:bg-gray-700 text-xs text-gray-800 dark:text-gray-100"
                >
                  Top {{ topN }}
                </button>
              </div>
            </div>
            <div class="mb-4 flex flex-wrap items-center gap-3">
              <div class="min-w-[260px]">
                <div class="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Agentes</div>
                <select
                  v-model="mediaAgenteSelecionado"
                  class="w-full px-3 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all text-sm"
                >
                  <option value="" class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">Top {{ topN }}</option>
                  <option
                    v-for="ag in agentesOpcoes"
                    :key="ag"
                    :value="ag"
                    class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                  >
                    {{ ag }}
                  </option>
                </select>
                <div class="mt-1 text-xs text-gray-600 dark:text-gray-300">
                  {{ mediaAgenteSelecionado ? `Selecionado: ${mediaAgenteSelecionado}` : `Usando Top ${topN}` }}
                </div>
              </div>
            </div>
            <div class="h-[420px]">
              <Bar v-if="mediaChartType === 'bar'" :data="chartMediaAgentesData" :options="chartMediaAgentesOptions" />
              <Line v-else-if="mediaChartType === 'line'" :data="chartMediaAgentesLineData" :options="chartMediaAgentesLineOptions" />
              <Radar v-else-if="mediaChartType === 'radar'" :data="chartMediaAgentesLineData" :options="chartMediaAgentesRadarOptions" />
              <Doughnut v-else :data="chartMediaAgentesDoughnutData" :options="chartMediaAgentesDoughnutOptions" />
            </div>
          </div>

          <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
            <div class="px-5 py-4 bg-slate-50 dark:bg-gray-900/40 border-b border-gray-200 dark:border-gray-700 flex flex-wrap items-center justify-between gap-2">
              <div class="flex flex-wrap items-center gap-3">
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Agentes (quantidade no período)</div>
                <div class="text-xs text-gray-600 dark:text-gray-300">
                  {{ agentesTotal }} agente(s)
                </div>
              </div>
              <div class="flex flex-wrap items-center gap-2">
                <select
                  v-model.number="agentesPageSize"
                  class="px-2 py-1 rounded border border-gray-300 dark:border-white/10 bg-white/60 dark:bg-white/5 text-gray-900 dark:text-white text-xs"
                >
                  <option :value="5">5</option>
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
                <button
                  @click="agentesPage = Math.max(1, agentesPage - 1)"
                  :disabled="agentesPage <= 1 || isLoadingAgentes"
                  class="px-3 py-1 rounded bg-slate-100 dark:bg-gray-700 text-xs text-gray-800 dark:text-gray-100 disabled:opacity-60"
                >
                  Anterior
                </button>
                <div class="text-xs text-gray-700 dark:text-gray-200">
                  Página {{ agentesPage }} / {{ agentesTotalPages }}
                </div>
                <button
                  @click="agentesPage = Math.min(agentesTotalPages, agentesPage + 1)"
                  :disabled="agentesPage >= agentesTotalPages || isLoadingAgentes"
                  class="px-3 py-1 rounded bg-slate-100 dark:bg-gray-700 text-xs text-gray-800 dark:text-gray-100 disabled:opacity-60"
                >
                  Próxima
                </button>
              </div>
              <button
                v-if="filtroAgenteValido"
                @click="filtroAgente = ''"
                class="px-3 py-1 rounded bg-slate-100 dark:bg-gray-700 text-xs text-gray-800 dark:text-gray-100"
              >
                Limpar agente
              </button>
            </div>
            <div class="p-4 overflow-x-auto">
              <table class="min-w-full text-sm">
                <thead>
                  <tr class="bg-slate-100 dark:bg-gray-800">
                    <th class="px-4 py-2 text-left font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">Agente</th>
                    <th class="px-4 py-2 text-left font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in agentesPagina"
                    :key="row.agente"
                    class="border-t border-gray-200 dark:border-gray-700 hover:bg-white/60 dark:hover:bg-white/5 transition-colors cursor-pointer"
                    @click="selecionarAgente(row.agente)"
                  >
                    <td class="px-4 py-2 text-gray-800 dark:text-gray-200 whitespace-nowrap">{{ row.agente }}</td>
                    <td class="px-4 py-2 text-gray-800 dark:text-gray-200 whitespace-nowrap">{{ row.quantidade }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
            <div class="px-5 py-4 bg-slate-50 dark:bg-gray-900/40 border-b border-gray-200 dark:border-gray-700">
              <div class="flex flex-wrap items-center justify-between gap-2">
                <div class="text-sm font-semibold text-gray-900 dark:text-white">Batidas recebidas</div>
                <div class="text-xs text-gray-600 dark:text-gray-300">
                  {{ historico.length }} registro(s)
                </div>
              </div>
            </div>
            <div class="p-4 overflow-x-auto">
              <table class="min-w-full text-sm">
                <thead>
                  <tr class="bg-slate-100 dark:bg-gray-800">
                    <th class="px-4 py-2 text-left font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">Data/Hora</th>
                    <th class="px-4 py-2 text-left font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">Unidade</th>
                    <th class="px-4 py-2 text-left font-semibold text-gray-700 dark:text-gray-200 whitespace-nowrap">Total linhas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in historicoResumo"
                    :key="row.id"
                    class="border-t border-gray-200 dark:border-gray-700"
                  >
                    <td class="px-4 py-2 text-gray-800 dark:text-gray-200 whitespace-nowrap">{{ formatarDataHora(row.timestamp) }}</td>
                    <td class="px-4 py-2 text-gray-800 dark:text-gray-200 whitespace-nowrap">{{ row.unidade_nome || 'N/I' }}</td>
                    <td class="px-4 py-2 text-gray-800 dark:text-gray-200 whitespace-nowrap">{{ row.total_linhas }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import apiClient from '@/services/authService';
import { Brush, RefreshCw, ArrowLeft } from 'lucide-vue-next';
import { Bar, Line, Radar, Doughnut } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, RadialLinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler, ChartDataLabels);

const unidades = ref([]);
const filtroUnidade = ref('');
const filtroCodigo = ref('');
const filtroAgente = ref('');
const dataInicio = ref('');
const dataFim = ref('');
const topN = ref(10);
const incluirSomenteAgenteFiltradoNoGrafico = ref(false);
const mostrarMediaMovel = ref(false);
const agentesPage = ref(1);
const agentesPageSize = ref(10);
const agentesTotal = ref(0);
const agentesPagina = ref([]);
const isLoadingAgentes = ref(false);
const agentesOpcoes = ref([]);
const isLoadingAgentesOpcoes = ref(false);
const mediaAgenteSelecionado = ref('');
const mediaChartType = ref('bar');
const mediaDoughnutMetric = ref('daily');

const codigosDisponiveis = ref([]);
const codigosResumo = ref([]);
const historico = ref([]);
const isLoading = ref(false);
const error = ref('');
const lastFetchTime = ref('');

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
const segmentSkipped = (ctx, value) => (ctx?.p0?.skip || ctx?.p1?.skip ? value : undefined);
const segmentDown = (ctx, value) => (ctx?.p0?.parsed?.y > ctx?.p1?.parsed?.y ? value : undefined);
const getIsDark = () => {
  try {
    return document?.documentElement?.classList?.contains('dark') || false;
  } catch {
    return false;
  }
};
const chartTextColor = computed(() => (getIsDark() ? '#e5e7eb' : '#374151'));
const chartGridColor = computed(() => (getIsDark() ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.08)'));

const formatarDataHora = (iso) => {
  try {
    return new Date(iso).toLocaleString('pt-BR');
  } catch {
    return iso || '';
  }
};

const formatarDia = (dia) => {
  if (!dia) return '-';
  if (!dateRegex.test(dia)) return dia;
  const [y, m, d] = dia.split('-');
  return `${d}/${m}/${y}`;
};

const carregarUnidades = async () => {
  try {
    const response = await apiClient.get('/api/v1/diversos/unidades-disponiveis/');
    unidades.value = response.data?.unidades || [];
  } catch (err) {
    unidades.value = [];
  }
};

const carregarCodigos = async () => {
  try {
    const params = {};
    if (filtroUnidade.value) params.unidade_id = filtroUnidade.value;
    const response = await apiClient.get('/api/v1/diversos/', { params });
    const grupos = response.data?.diversos || [];
    codigosDisponiveis.value = grupos.map((g) => g.codigo).filter(Boolean);
    codigosResumo.value = grupos.map((g) => {
      const items = Array.isArray(g.diversos) ? g.diversos : [];
      const ultima = items.reduce((acc, it) => {
        const ts = String(it?.timestamp || '');
        if (!ts) return acc;
        if (!acc) return ts;
        return ts > acc ? ts : acc;
      }, '');
      const unidades = items.map((it) => it?.unidade_nome).filter(Boolean);
      const uniqueUnidades = Array.from(new Set(unidades));
      const preview = uniqueUnidades.slice(0, 3);
      return {
        codigo: g.codigo,
        total_unidades: uniqueUnidades.length || items.length || 0,
        ultima_batida: ultima || '',
        unidades_preview: preview,
        unidades_mais: Math.max(0, uniqueUnidades.length - preview.length),
      };
    }).filter((x) => x.codigo);
  } catch {
    codigosDisponiveis.value = [];
    codigosResumo.value = [];
  }
};

const carregarHistorico = async (opts = {}) => {
  if (!filtroCodigo.value) {
    historico.value = [];
    return;
  }

  const shouldKeepEnd = !!(dataFim.value && dataFim.value === maxDiaDisponivel.value);

  isLoading.value = true;
  error.value = '';
  try {
    const params = { codigo: filtroCodigo.value, limit: 5000 };
    if (filtroUnidade.value) params.unidade_id = filtroUnidade.value;
    if (opts.useDateFilter && dataInicio.value) params.start_date = dataInicio.value;
    if (opts.useDateFilter && dataFim.value) params.end_date = dataFim.value;

    const response = await apiClient.get('/api/v1/diversos/historico/', { params });
    historico.value = response.data?.diversos || [];
    lastFetchTime.value = new Date().toLocaleString('pt-BR');

    if (!dataInicio.value && minDiaDisponivel.value) dataInicio.value = minDiaDisponivel.value;
    if (!dataFim.value && maxDiaDisponivel.value) dataFim.value = maxDiaDisponivel.value;

    if (minDiaDisponivel.value && dataInicio.value && dataInicio.value < minDiaDisponivel.value) dataInicio.value = minDiaDisponivel.value;
    if (maxDiaDisponivel.value && dataFim.value && dataFim.value > maxDiaDisponivel.value) dataFim.value = maxDiaDisponivel.value;
    if (dataInicio.value && dataFim.value && dataInicio.value > dataFim.value) dataFim.value = dataInicio.value;
    if (shouldKeepEnd && maxDiaDisponivel.value) {
      dataFim.value = maxDiaDisponivel.value;
    }
  } catch (err) {
    historico.value = [];
    error.value = 'Não foi possível carregar os SQLs diversos. Tente novamente.';
  } finally {
    isLoading.value = false;
  }
};

const loadCachedDates = () => {
  try {
    const di = localStorage.getItem('diversos_data_inicio') || '';
    const df = localStorage.getItem('diversos_data_fim') || '';
    if (di && dateRegex.test(di)) dataInicio.value = di;
    if (df && dateRegex.test(df)) dataFim.value = df;
  } catch {
    return;
  }
};

watch(
  () => [dataInicio.value, dataFim.value],
  ([di, df]) => {
    try {
      localStorage.setItem('diversos_data_inicio', di || '');
      localStorage.setItem('diversos_data_fim', df || '');
    } catch {
      return;
    }
  }
);

const carregarAgentes = async () => {
  if (!filtroCodigo.value) {
    agentesTotal.value = 0;
    agentesPagina.value = [];
    return;
  }
  isLoadingAgentes.value = true;
  try {
    const params = {
      codigo: filtroCodigo.value,
      page: agentesPage.value,
      page_size: agentesPageSize.value,
    };
    if (filtroUnidade.value) params.unidade_id = filtroUnidade.value;
    if (dataInicioEfetiva.value) params.start_date = dataInicioEfetiva.value;
    if (dataFimEfetiva.value) params.end_date = dataFimEfetiva.value;

    const response = await apiClient.get('/api/v1/diversos/agentes/', { params });
    agentesPagina.value = response.data?.agentes || [];
    agentesTotal.value = response.data?.total || 0;
  } catch {
    agentesPagina.value = [];
    agentesTotal.value = 0;
  } finally {
    isLoadingAgentes.value = false;
  }
};

const carregarAgentesOpcoes = async () => {
  if (!filtroCodigo.value) {
    agentesOpcoes.value = [];
    return;
  }

  isLoadingAgentesOpcoes.value = true;
  try {
    const params = {
      codigo: filtroCodigo.value,
      page: 1,
      page_size: 200,
    };
    if (filtroUnidade.value) params.unidade_id = filtroUnidade.value;
    if (dataInicioEfetiva.value) params.start_date = dataInicioEfetiva.value;
    if (dataFimEfetiva.value) params.end_date = dataFimEfetiva.value;

    const response = await apiClient.get('/api/v1/diversos/agentes/', { params });
    const lista = (response.data?.agentes || []).map((x) => x.agente).filter(Boolean);
    agentesOpcoes.value = Array.from(new Set(lista)).sort((a, b) => String(a).localeCompare(String(b)));
    if (filtroAgente.value && !agentesOpcoes.value.includes(filtroAgente.value)) {
      filtroAgente.value = '';
    }
  } catch {
    agentesOpcoes.value = [];
  } finally {
    isLoadingAgentesOpcoes.value = false;
  }
};

const selecionarAgente = (agente) => {
  if (!agente) {
    filtroAgente.value = '';
    return;
  }
  if (!agentesOpcoes.value.includes(agente)) {
    agentesOpcoes.value = [...agentesOpcoes.value, agente].sort((a, b) => String(a).localeCompare(String(b)));
  }
  filtroAgente.value = agente;
};

const filtrarHoje = async () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const today = `${y}-${m}-${d}`;

  dataInicio.value = today;
  dataFim.value = today;
  agentesPage.value = 1;

  if (filtroCodigo.value) {
    await carregarHistorico({ useDateFilter: true });
    await carregarAgentesOpcoes();
    await carregarAgentes();
  }
};

const limparFiltros = async () => {
  filtroUnidade.value = '';
  filtroCodigo.value = '';
  filtroAgente.value = '';
  dataInicio.value = '';
  dataFim.value = '';
  agentesPage.value = 1;
  await atualizarTudo();
};

const atualizarTudo = async () => {
  await carregarUnidades();
  await carregarCodigos();
  if (filtroCodigo.value) {
    await carregarHistorico({ useDateFilter: true });
    await carregarAgentesOpcoes();
    await carregarAgentes();
  } else {
    historico.value = [];
    agentesPagina.value = [];
    agentesTotal.value = 0;
    agentesOpcoes.value = [];
  }
};

const selecionarCodigo = (codigo) => {
  filtroCodigo.value = codigo;
};

const voltarLista = () => {
  filtroCodigo.value = '';
  filtroAgente.value = '';
  agentesPage.value = 1;
};

const parseQuantidade = (row) => {
  const cand = row?.numerador ?? row?.quantidade ?? row?.qtd ?? row?.total;
  const n = Number.parseInt(String(cand ?? '').replace(/\D+/g, ''), 10);
  if (Number.isFinite(n)) return n;
  return null;
};

const addDays = (isoDay, days) => {
  const d = new Date(`${isoDay}T00:00:00`);
  d.setDate(d.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
};

const rangeDays = (startDay, endDay) => {
  if (!startDay || !endDay || !dateRegex.test(startDay) || !dateRegex.test(endDay)) return [];
  if (startDay > endDay) return [];
  const out = [];
  let d = startDay;
  while (d <= endDay) {
    out.push(d);
    d = addDays(d, 1);
  }
  return out;
};

const isoWeekKeyFromIsoDay = (isoDay) => {
  const date = new Date(`${isoDay}T00:00:00`);
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  const isoYear = d.getUTCFullYear();
  const wk = String(weekNo).padStart(2, '0');
  return `${isoYear}-W${wk}`;
};

const normalizeFromHistorico = (items) => {
  const latest = new Map();
  for (const item of items || []) {
    const dados = Array.isArray(item?.dados) ? item.dados : [];
    const ts = String(item?.timestamp || '');
    const unidadeKey = item?.unidade_id ?? 0;
    for (const r of dados) {
      if (!r || typeof r !== 'object') continue;
      const titulo = String(r.titulo ?? '').trim();
      const valor = String(r.valor ?? '').trim();
      if (!titulo || !valor) continue;
      if (titulo.toUpperCase() === 'SET' || valor.toUpperCase() === 'SET') continue;

      const quantidade = parseQuantidade(r);
      if (quantidade === null) continue;

      const dia = dateRegex.test(titulo) ? titulo : null;
      if (!dia) continue;

      const key = `${unidadeKey}__${dia}__${valor}`;
      const prev = latest.get(key);
      if (!prev || ts > prev.timestamp) {
        latest.set(key, {
          dia,
          agente: valor,
          quantidade,
          timestamp: ts,
          unidade_id: item.unidade_id,
          unidade_nome: item.unidade_nome,
        });
      }
    }
  }
  return Array.from(latest.values());
};

const linhasNormalizadas = computed(() => normalizeFromHistorico(historico.value));

const diasDisponiveis = computed(() => {
  const set = new Set(linhasNormalizadas.value.map((r) => r.dia));
  return Array.from(set).sort();
});

const minDiaDisponivel = computed(() => (diasDisponiveis.value.length ? diasDisponiveis.value[0] : ''));
const maxDiaDisponivel = computed(() => (diasDisponiveis.value.length ? diasDisponiveis.value[diasDisponiveis.value.length - 1] : ''));

const dataInicioEfetiva = computed(() => dataInicio.value || minDiaDisponivel.value);
const dataFimEfetiva = computed(() => dataFim.value || maxDiaDisponivel.value);

const filtroAgenteValido = computed(() => {
  return !!filtroAgente.value;
});

const linhasFiltradas = computed(() => {
  const start = dataInicioEfetiva.value;
  const end = dataFimEfetiva.value;
  const ag = filtroAgenteValido.value ? filtroAgente.value : '';
  return linhasNormalizadas.value.filter((r) => {
    if (start && r.dia < start) return false;
    if (end && r.dia > end) return false;
    if (ag && r.agente !== ag) return false;
    return true;
  });
});

const totalQuantidade = computed(() => linhasFiltradas.value.reduce((acc, r) => acc + r.quantidade, 0));
const totalAgentes = computed(() => {
  const set = new Set(linhasFiltradas.value.map((r) => r.agente));
  return set.size;
});

const ultimaBatida = computed(() => {
  if (!historico.value.length) return '';
  const last = [...historico.value].sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)))[0];
  return last?.timestamp || '';
});

const unidadeSelecionadaNome = computed(() => {
  if (!filtroUnidade.value) return '';
  const u = unidades.value.find((x) => String(x.id) === String(filtroUnidade.value));
  return u?.nome || '';
});

const agregacaoPorDia = computed(() => {
  const map = new Map();
  for (const r of linhasFiltradas.value) {
    map.set(r.dia, (map.get(r.dia) || 0) + r.quantidade);
  }
  return Array.from(map.entries()).sort((a, b) => a[0].localeCompare(b[0])).map(([dia, quantidade]) => ({ dia, quantidade }));
});

const diasDoIntervaloSelecionado = computed(() => rangeDays(dataInicioEfetiva.value, dataFimEfetiva.value));
const diasBaseParaMedias = computed(() => (diasDoIntervaloSelecionado.value.length ? diasDoIntervaloSelecionado.value : diasDisponiveis.value));
const mediaBaseDias = computed(() => diasBaseParaMedias.value.length);
const mediaBaseSemanas = computed(() => {
  const set = new Set(diasBaseParaMedias.value.map((d) => isoWeekKeyFromIsoDay(d)));
  return set.size || 0;
});
const mediaBaseMeses = computed(() => {
  const set = new Set(diasBaseParaMedias.value.map((d) => String(d).slice(0, 7)));
  return set.size || 0;
});

const agregacaoPorDiaSerie = computed(() => {
  const map = new Map(agregacaoPorDia.value.map((x) => [x.dia, x.quantidade]));
  const days = diasDoIntervaloSelecionado.value.length ? diasDoIntervaloSelecionado.value : diasDisponiveis.value;
  return days.map((dia) => ({ dia, quantidade: map.has(dia) ? map.get(dia) : Number.NaN }));
});

const agregacaoPorDiaSerieZero = computed(() => {
  const map = new Map(agregacaoPorDia.value.map((x) => [x.dia, x.quantidade]));
  const days = diasDoIntervaloSelecionado.value.length ? diasDoIntervaloSelecionado.value : diasDisponiveis.value;
  return days.map((dia) => ({ dia, quantidade: map.has(dia) ? map.get(dia) : 0 }));
});

const agregacaoPorAgente = computed(() => {
  const map = new Map();
  for (const r of linhasFiltradas.value) {
    map.set(r.agente, (map.get(r.agente) || 0) + r.quantidade);
  }
  return Array.from(map.entries())
    .map(([agente, quantidade]) => ({ agente, quantidade }))
    .sort((a, b) => b.quantidade - a.quantidade);
});

const agentesTotalPages = computed(() => {
  const ps = Number(agentesPageSize.value) || 10;
  const total = Number(agentesTotal.value) || 0;
  const pages = Math.ceil(total / Math.max(1, ps));
  return pages || 1;
});

const historicoResumo = computed(() => {
  const rows = [...historico.value].sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)));
  return rows.map((r) => ({
    id: r.id,
    timestamp: r.timestamp,
    unidade_nome: r.unidade_nome,
    total_linhas: Array.isArray(r.dados) ? r.dados.length : 0,
  }));
});

const chartTotalPorDiaData = computed(() => {
  const labels = agregacaoPorDiaSerie.value.map((x) => formatarDia(x.dia));
  const values = agregacaoPorDiaSerie.value.map((x) => x.quantidade);
  return {
    labels,
    datasets: [
      {
        label: 'Total',
        data: values,
        borderColor: 'rgb(37, 99, 235)',
        backgroundColor: 'rgba(37, 99, 235, 0.14)',
        segment: {
          borderColor: (ctx) => segmentSkipped(ctx, 'rgba(0,0,0,0.2)') || segmentDown(ctx, 'rgb(192,75,75)'),
          borderDash: (ctx) => segmentSkipped(ctx, [6, 6]),
        },
        spanGaps: true,
        tension: 0.25,
        fill: true,
        pointRadius: 3,
      },
    ],
  };
});

const chartTotalPorDiaOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  scales: {
    x: { ticks: { maxRotation: 0, autoSkip: true, color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const chartAcumuladoData = computed(() => {
  const labels = agregacaoPorDiaSerieZero.value.map((x) => formatarDia(x.dia));
  const values = [];
  let acc = 0;
  for (const x of agregacaoPorDiaSerieZero.value) {
    acc += Number(x.quantidade || 0);
    values.push(acc);
  }

  return {
    labels,
    datasets: [
      {
        label: 'Acumulado',
        data: values,
        borderColor: 'rgb(99, 102, 241)',
        backgroundColor: 'rgba(99, 102, 241, 0.12)',
        tension: 0.25,
        fill: true,
        pointRadius: 2,
      },
    ],
  };
});

const chartAcumuladoOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  scales: {
    x: { ticks: { maxRotation: 0, autoSkip: true, color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const movingAverage = (arr, windowSize) => {
  if (!Array.isArray(arr) || !arr.length) return [];
  const out = [];
  for (let i = 0; i < arr.length; i += 1) {
    const start = Math.max(0, i - windowSize + 1);
    let sum = 0;
    let count = 0;
    for (let j = start; j <= i; j += 1) {
      const v = arr[j];
      if (Number.isFinite(v)) {
        sum += v;
        count += 1;
      }
    }
    out.push(count ? sum / count : Number.NaN);
  }
  return out;
};

const coresAgentes = [
  'rgb(59, 130, 246)',
  'rgb(16, 185, 129)',
  'rgb(234, 179, 8)',
  'rgb(239, 68, 68)',
  'rgb(168, 85, 247)',
  'rgb(14, 165, 233)',
  'rgb(245, 158, 11)',
  'rgb(34, 197, 94)',
  'rgb(124, 58, 237)',
  'rgb(236, 72, 153)',
];

const agentesTopParaSerie = computed(() => {
  if (incluirSomenteAgenteFiltradoNoGrafico.value && filtroAgenteValido.value) {
    return [filtroAgente.value];
  }
  return agregacaoPorAgente.value
    .slice(0, Math.max(3, Math.min(20, Number(topN.value) || 10)))
    .map((x) => x.agente);
});

const chartAgentesPorDiaData = computed(() => {
  const days = diasDoIntervaloSelecionado.value.length ? diasDoIntervaloSelecionado.value : diasDisponiveis.value;
  const labels = days.map((d) => formatarDia(d));
  const index = new Map(days.map((d, i) => [d, i]));

  const map = new Map();
  for (const r of linhasFiltradas.value) {
    if (!index.has(r.dia)) continue;
    const key = `${r.agente}__${r.dia}`;
    map.set(key, (map.get(key) || 0) + r.quantidade);
  }

  const datasets = agentesTopParaSerie.value.map((agente, idx) => {
    const data = new Array(days.length).fill(Number.NaN);
    for (const d of days) {
      const key = `${agente}__${d}`;
      if (map.has(key)) {
        data[index.get(d)] = map.get(key);
      }
    }

    const cor = coresAgentes[idx % coresAgentes.length];
    return {
      label: agente,
      data,
      borderColor: cor,
      backgroundColor: cor.replace('rgb(', 'rgba(').replace(')', ', 0.10)'),
      segment: {
        borderColor: (ctx) => segmentSkipped(ctx, 'rgba(0,0,0,0.2)') || segmentDown(ctx, 'rgb(192,75,75)'),
        borderDash: (ctx) => segmentSkipped(ctx, [6, 6]),
      },
      spanGaps: true,
      tension: 0.2,
      pointRadius: 2,
      fill: false,
    };
  });

  if (mostrarMediaMovel.value) {
    const totalSeries = agregacaoPorDiaSerie.value.map((x) => (Number.isFinite(x.quantidade) ? x.quantidade : Number.NaN));
    const ma = movingAverage(totalSeries, 7);
    datasets.unshift({
      label: 'Total (média móvel 7d)',
      data: ma,
      borderColor: getIsDark() ? 'rgb(226, 232, 240)' : 'rgb(15, 23, 42)',
      backgroundColor: getIsDark() ? 'rgba(226, 232, 240, 0.06)' : 'rgba(15, 23, 42, 0.08)',
      borderWidth: 2,
      segment: {
        borderColor: (ctx) => segmentSkipped(ctx, 'rgba(0,0,0,0.2)') || segmentDown(ctx, 'rgb(192,75,75)'),
        borderDash: (ctx) => segmentSkipped(ctx, [6, 6]),
      },
      spanGaps: true,
      tension: 0.25,
      pointRadius: 0,
      fill: false,
    });
  }

  return { labels, datasets };
});

const chartAgentesPorDiaOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: { boxWidth: 10, boxHeight: 10, color: chartTextColor.value },
    },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  interaction: { mode: 'index', intersect: false },
  scales: {
    x: { ticks: { maxRotation: 0, autoSkip: true, color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const chartTopAgentesData = computed(() => {
  const top = agregacaoPorAgente.value.slice(0, Math.max(3, Math.min(50, Number(topN.value) || 10)));
  return {
    labels: top.map((x) => x.agente),
    datasets: [
      {
        label: 'Quantidade',
        data: top.map((x) => x.quantidade),
        backgroundColor: 'rgba(16, 185, 129, 0.85)',
        borderColor: '#059669',
        borderWidth: 1,
      },
    ],
  };
});

const chartTopAgentesOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    datalabels: {
      anchor: 'end',
      align: 'end',
      color: chartTextColor.value,
      formatter: (v) => v,
      clamp: true,
    },
    tooltip: { mode: 'index', intersect: false },
  },
  scales: {
    x: { ticks: { autoSkip: false, maxRotation: 60, minRotation: 0, color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const agentesTopParaMedia = computed(() => {
  const top = agregacaoPorAgente.value.slice(0, Math.max(3, Math.min(50, Number(topN.value) || 10)));
  return top.map((x) => x.agente);
});

const mediaAgentsFinal = computed(() => {
  if (mediaAgenteSelecionado.value) return [mediaAgenteSelecionado.value];
  return agentesTopParaMedia.value;
});

const chartMediaAgentesData = computed(() => {
  const agents = mediaAgentsFinal.value;
  const totals = new Map(agregacaoPorAgente.value.map((x) => [x.agente, x.quantidade]));

  const dCount = Math.max(1, mediaBaseDias.value || 0);
  const wCount = Math.max(1, mediaBaseSemanas.value || 0);
  const mCount = Math.max(1, mediaBaseMeses.value || 0);

  const daily = agents.map((a) => (totals.get(a) || 0) / dCount);
  const weekly = agents.map((a) => (totals.get(a) || 0) / wCount);
  const monthly = agents.map((a) => (totals.get(a) || 0) / mCount);

  return {
    labels: agents,
    datasets: [
      {
        label: 'Média diária',
        data: daily,
        backgroundColor: 'rgba(59, 130, 246, 0.70)',
        borderColor: 'rgb(59, 130, 246)',
        borderWidth: 1,
      },
      {
        label: 'Média semanal',
        data: weekly,
        backgroundColor: 'rgba(16, 185, 129, 0.70)',
        borderColor: 'rgb(16, 185, 129)',
        borderWidth: 1,
      },
      {
        label: 'Média mensal',
        data: monthly,
        backgroundColor: 'rgba(234, 179, 8, 0.75)',
        borderColor: 'rgb(234, 179, 8)',
        borderWidth: 1,
      },
    ],
  };
});

const chartMediaAgentesOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: { boxWidth: 10, boxHeight: 10, color: chartTextColor.value },
    },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  interaction: { mode: 'index', intersect: false },
  scales: {
    x: { ticks: { autoSkip: false, maxRotation: 60, minRotation: 0, color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const chartMediaAgentesLineData = computed(() => {
  const agents = mediaAgentsFinal.value;
  const totals = new Map(agregacaoPorAgente.value.map((x) => [x.agente, x.quantidade]));

  const dCount = Math.max(1, mediaBaseDias.value || 0);
  const wCount = Math.max(1, mediaBaseSemanas.value || 0);
  const mCount = Math.max(1, mediaBaseMeses.value || 0);

  const labels = ['Diária', 'Semanal', 'Mensal'];
  const datasets = agents.map((ag, idx) => {
    const total = totals.get(ag) || 0;
    const cor = coresAgentes[idx % coresAgentes.length];
    return {
      label: ag,
      data: [total / dCount, total / wCount, total / mCount],
      borderColor: cor,
      backgroundColor: cor.replace('rgb(', 'rgba(').replace(')', ', 0.16)'),
      tension: 0.25,
      pointRadius: 3,
      fill: false,
    };
  });

  return { labels, datasets };
});

const chartMediaAgentesLineOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: { boxWidth: 10, boxHeight: 10, color: chartTextColor.value },
    },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  interaction: { mode: 'index', intersect: false },
  scales: {
    x: { ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
    y: { beginAtZero: true, ticks: { color: chartTextColor.value }, grid: { color: chartGridColor.value } },
  },
}));

const chartMediaAgentesRadarOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: { boxWidth: 10, boxHeight: 10, color: chartTextColor.value },
    },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
  scales: {
    r: {
      beginAtZero: true,
      grid: { color: chartGridColor.value },
      angleLines: { color: chartGridColor.value },
      pointLabels: { color: chartTextColor.value },
      ticks: { color: chartTextColor.value },
    },
  },
}));

const chartMediaAgentesDoughnutData = computed(() => {
  const agents = mediaAgentsFinal.value;
  const totals = new Map(agregacaoPorAgente.value.map((x) => [x.agente, x.quantidade]));

  const dCount = Math.max(1, mediaBaseDias.value || 0);
  const wCount = Math.max(1, mediaBaseSemanas.value || 0);
  const mCount = Math.max(1, mediaBaseMeses.value || 0);

  const metric = String(mediaDoughnutMetric.value || 'daily');
  const values = agents.map((ag) => {
    const total = totals.get(ag) || 0;
    if (metric === 'weekly') return total / wCount;
    if (metric === 'monthly') return total / mCount;
    return total / dCount;
  });

  const colors = agents.map((_, idx) => coresAgentes[idx % coresAgentes.length].replace('rgb(', 'rgba(').replace(')', ', 0.80)'));

  return {
    labels: agents,
    datasets: [
      {
        label: 'Média',
        data: values,
        backgroundColor: colors,
        borderColor: colors.map((c) => c.replace(', 0.80)', ', 1)')),
        borderWidth: 1,
      },
    ],
  };
});

const chartMediaAgentesDoughnutOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: { boxWidth: 10, boxHeight: 10, color: chartTextColor.value },
    },
    datalabels: { display: false },
    tooltip: { mode: 'index', intersect: false },
  },
}));

const limparSelecaoMediaAgentes = () => {
  mediaAgenteSelecionado.value = '';
};

watch(
  () => filtroUnidade.value,
  async () => {
    agentesPage.value = 1;
    await carregarCodigos();
    if (filtroCodigo.value) {
      await carregarHistorico({ useDateFilter: true });
      await carregarAgentesOpcoes();
      await carregarAgentes();
    }
  }
);

watch(
  () => filtroCodigo.value,
  async () => {
    filtroAgente.value = '';
    agentesPage.value = 1;
    if (filtroCodigo.value) {
      await carregarHistorico({ useDateFilter: true });
      await carregarAgentesOpcoes();
      await carregarAgentes();
    } else {
      historico.value = [];
      agentesPagina.value = [];
      agentesTotal.value = 0;
      agentesOpcoes.value = [];
    }
  }
);

watch(
  () => [dataInicio.value, dataFim.value],
  async ([di, df]) => {
    if (!filtroCodigo.value) return;
    if (di && df && di > df) {
      dataFim.value = di;
      return;
    }
    if (di || df) {
      await carregarHistorico({ useDateFilter: true });
      agentesPage.value = 1;
      await carregarAgentesOpcoes();
      await carregarAgentes();
    }
  }
);

watch(
  () => [agentesPage.value, agentesPageSize.value],
  async () => {
    if (!filtroCodigo.value) return;
    if (agentesPage.value < 1) agentesPage.value = 1;
    if (agentesPage.value > agentesTotalPages.value) agentesPage.value = agentesTotalPages.value;
    await carregarAgentes();
  }
);

onMounted(async () => {
  loadCachedDates();
  await atualizarTudo();
});

const codigosCards = computed(() => [...codigosResumo.value].sort((a, b) => String(a.codigo).localeCompare(String(b.codigo))));
const ultimaBatidaGeral = computed(() => {
  const ts = codigosCards.value.map((c) => c.ultima_batida).filter(Boolean).sort().pop();
  return ts || '';
});
</script>
